import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

import Select from 'react-select';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import getLocale from '../../i18n/getLocale';

class StaffRfmsReportIndex extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      data: [],
      staff_list: [],
    };
    
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.ActionsButtons = this.ActionsButtons.bind(this);
    this.loadData = this.loadData.bind(this);
    this.sortDates = this.sortDates.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/relatorios-de-fadiga/tripulante', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }
  

  ActionsButtons (cell, row) {
    var url = '/relatorio-de-fadiga/tripulante/editar/' + cell;
    var botao = (
      <div className="btn-group">
          <Link className={'btn btn-primary btn-sm'} to={url}>
            <i className="fa fa-fw fa-pencil"></i>
          </Link>
      </div>
    );

    return botao;
  }
  
 sortDates (a, b, order) {
    let indices = [6, 7, 8, 9, 3, 4, 0, 1];
    if (order === 'asc') {
      let r = 0;
      indices.find(i => r = a.date.charCodeAt(i) - b.date.charCodeAt(i));
      return r;
    } else if (order === 'desc') {
      let r = 0;
      indices.find(i => r = b.date.toString().charCodeAt(i) - a.date.toString().charCodeAt(i));
      return r;
    }
  }  

  render() {
    return (
<div>
  
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <Link to="/relatorio-de-fadiga/cadastrar" className="btn btn-primary pull-right"><i className="fa fa-plus"></i> {this.locale.RelatoriosDeFadiga.ListaDeRelatoriosDeFadigas.botaoAdicionarRelatorioDeFadiga}</Link>
      <h3 className="page-title pull-left">{this.locale.RelatoriosDeFadiga.ListaDeRelatoriosDeFadigas.titulo}</h3>
      <div className="clearfix"></div>
      <hr/>
      <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.RelatoriosDeFadiga.ListaDeRelatoriosDeFadigas.tabela.semParametroDeFadiga}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>

        <TableHeaderColumn isKey={true} sortFunc={ this.sortDates } dataField="date_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.RelatoriosDeFadiga.ListaDeRelatoriosDeFadigas.tabela.Data}</TableHeaderColumn>
        <TableHeaderColumn dataField="revision" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.RelatoriosDeFadiga.ListaDeRelatoriosDeFadigas.tabela.Revisao}</TableHeaderColumn>
        <TableHeaderColumn dataField="staff" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='240'>{this.locale.RelatoriosDeFadiga.ListaDeRelatoriosDeFadigas.tabela.Tripulante}</TableHeaderColumn>
        <TableHeaderColumn dataField="day_off_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.RelatoriosDeFadiga.ListaDeRelatoriosDeFadigas.tabela.Folga}?</TableHeaderColumn>
        <TableHeaderColumn dataField="actual_points_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.RelatoriosDeFadiga.ListaDeRelatoriosDeFadigas.tabela.QuantidadeDePontosAtual}</TableHeaderColumn>
        <TableHeaderColumn dataField="report_points_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.RelatoriosDeFadiga.ListaDeRelatoriosDeFadigas.tabela.QuantidadeDePontosReportados}</TableHeaderColumn>

        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='60'>{this.locale.RelatoriosDeFadiga.ListaDeRelatoriosDeFadigas.tabela.Acoes}</TableHeaderColumn>

      </BootstrapTable>
    </div>
  </div>
</div>
    );
  }
}

export default StaffRfmsReportIndex;



// WEBPACK FOOTER //
// ./src/Components/StaffRfmsReport/StaffRfmsReportIndex.js